module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.a1a0ed86.eot";